import React from 'react';
import { Redirect, Route } from 'react-router';

import SingleCard from '../../appComponents/singleCard';
import LoginForm from '../login';

const Auth = () => {
  return (
    <Route>
      <Route exact path="/login">
        <div style={{ width: 400, margin: 'auto', marginTop: 100 }}>
          <SingleCard title="Авторизация">
            <LoginForm />
          </SingleCard>
        </div>
      </Route>
      <Route exact path="/reset-password">
        <SingleCard
          title="Сброс пароля"
          description="Пожалуйста, введите адрес электронной почты, который вы использовали для регистрации, и мы отправим вам код для сброса пароля по электронной почте."
        >
          {/* <ResetPasswordForm /> */}
        </SingleCard>
      </Route>

      <Redirect to={'/login'} />
    </Route>
  );
};

export default Auth;
